import { ScrollTo } from './ScrollTo';

export const Pagination = () => {
  $('.js-pagination a').each(function() {
    $(this).on('click', () => ScrollTo($('body')));
  });
};

window.Pagination = () => Pagination();
